import { getMeUid } from '@selectors/auth';
import { captureException } from '@utils/sentry';
import { AnalyticsEventsError } from '@utils/customErrors';
import fetch from '@api/fetchers';
import { getStore } from 'src/redux';
import { readCookie } from './cookies';
import validateAndSetSessionId from './session/validateAndSetSessionId';

const DATA_ENDPOINT = process.env.UN_DATA_ENDPOINT;
const UA_ANALYTICS_ACCESS_TOKEN =
  process.env.ANALYTICS_TOKEN || 'kfh2kjhfiwewdsdsd'; // pragma: allowlist secret

// For grouping events together and sending them at once to minimizing request load on backend
let eventsBatch = [];
let eventsSendingTimer = null;

const createEventData = (eventName, eventData, user_id) => {
  return {
    user_id,
    event: eventName,
    ...eventData,
    time: Date.now(),
    value: 1
  };
};

const makeAnalyticsCall = async () => {
  validateAndSetSessionId();
  const headers = {
    accesstoken: UA_ANALYTICS_ACCESS_TOKEN,
    authorization: 'Bearer OK',
    'device-token': readCookie('accessToken') || '',
    'Content-Type': 'application/json'
  };
  const eventsToSend = [...eventsBatch];
  if (eventsToSend.length) {
    const options = {
      headers,
      useCamelCase: false,
      requestType: 'PUT',
      body: { events: eventsToSend }
    };
    eventsBatch = []; // Reset batch of events to send.
    eventsSendingTimer = clearTimeout(eventsSendingTimer); // Clear interval for the next analytics events call to come in.
    if (DATA_ENDPOINT) {
      const res = await fetch(`${DATA_ENDPOINT}/counts`, options);
      if (res.error) captureException(new AnalyticsEventsError(res.error));
    }
  }
};

const getMissingFieldFromEvent = (eventData = {}) => {
  let missingFields = '';
  const mandatoryFields = [
    'uid',
    'user_uid',
    'PLAYER_ID',
    'BROWSER_ID',
    'TOTAL_RUN_TIME'
  ];
  for (let i = 0; i < mandatoryFields.length; i += 1) {
    if (!eventData[mandatoryFields[i]])
      missingFields += `${mandatoryFields[i]}, `;
  }
  missingFields = missingFields.replace(/, $/, '');
  return missingFields;
};

const isValidWatchTimeEvent = (eventData) => {
  const missingFieldsFromEvent = getMissingFieldFromEvent(eventData);
  if (missingFieldsFromEvent.length) {
    captureException(
      new AnalyticsEventsError(
        `Missing fields from watch event at ${window.location.href}. Missing Fields: ${missingFieldsFromEvent}`
      )
    );
    return false;
  }
  if (typeof eventData.TOTAL_RUN_TIME === 'string') {
    captureException(
      new AnalyticsEventsError(
        `Invalid data found for watch event at ${window.location.href}`
      )
    );
    return false;
  }
  return true;
};

export async function sendPlayerAnalyticsEvent(
  event = 'lesson_watch_status',
  eventDataOriginal
) {
  const { getState } = getStore();
  const eventName = `frontend_${event}`;
  // Event Data Validation
  const sessionId = readCookie('anonymous_session_id') || '';
  const eventData = { ...eventDataOriginal, session_id: sessionId };
  if (
    eventName === 'frontend_lesson_watch_status' &&
    !isValidWatchTimeEvent(eventData)
  )
    return;

  const eventDataToSend = createEventData(
    eventName,
    eventData,
    getMeUid(getState())
  );
  // Wait for other events to come in for half a second, batch them together and make the call once 300ms are done.
  eventsBatch.push(eventDataToSend);
  eventsSendingTimer = setTimeout(makeAnalyticsCall, 300);
}

export default sendPlayerAnalyticsEvent;
